import * as types from './mutation-types'

export default {
  [types.SET_DADOS_COLLAPSE] (state, dados) {
    state.collapsedItems = dados
  },
  [types.LIMPAR_DADOS_COLLAPSE] (state) {
    state.collapsedItems = []
  }
}
